module.exports = __webpack_public_path__ + "static/scale-model-of-roswell-ghost-tour-in-sandy-springs-georgia-a5ba50aaccf87ab78a81cddd7e8d84f8.png";